import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { Component, inject, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, startWith, map } from 'rxjs';
import { DisbursmentService } from 'src/app/shared/service/disbursment/disbursment.service';
interface EmailDialogData {
  to?: string[];
  cc?: string[];
  lockCc?: boolean;
}
@Component({
  selector: 'app-email-dialog',
  templateUrl: './email-dialog.component.html',
  styleUrls: ['./email-dialog.component.scss']
})

export class EmailDialogComponent {
private loader = inject(DisbursmentService);
isLoading$ = this.loader.loading$;
  toEmailList: string[] = [];
  ccEmailList: string[] = [];

  selectedToEmails: string[] = [];
  selectedCcEmails: string[] = [];

  readonly separatorKeysCodes = [ENTER, COMMA] as const;

  to = new FormControl('', [Validators.email]);
  cc = new FormControl('', [Validators.email]);

  signatureData = sessionStorage.getItem('signature');
  email_signature = new FormControl(this.signatureData != null ? this.signatureData : '');
  update_signature = new FormControl('');

  filteredToOptions!: Observable<string[]>;
  filteredCcOptions!: Observable<string[]>;
isCcLocked = false;
  constructor(
    private dialogRef: MatDialogRef<EmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EmailDialogData
  ) {
    this.toEmailList = data?.to || [];
  this.ccEmailList = data?.cc || [];

  this.selectedToEmails = [...this.toEmailList];
  this.selectedCcEmails = [...this.ccEmailList];

  this.isCcLocked = data?.lockCc ?? false;
  }

  ngOnInit() {
    this.filteredToOptions = this.to.valueChanges.pipe(
      startWith(''),
      map(value => this.filterOptions(value || '', this.toEmailList)),
    );

    this.filteredCcOptions = this.cc.valueChanges.pipe(
      startWith(''),
      map(value => this.filterOptions(value || '', this.ccEmailList)),
    );
  }

  // method to filter options based on input
  private filterOptions(value: string, datasource: string[]): string[] {
    const filterValue = value.toLowerCase();
    return datasource.filter(option => option.toLowerCase().includes(filterValue));
  }

  private addEmailToSelection(email: string, targetArray: string[]): boolean {
    if (!email || targetArray.includes(email) || !this.isValidEmail(email)) {
      return false;
    }
    targetArray.push(email);
    return true;
  }

  private isValidEmail(email: string): boolean {
    return Validators.email({ value: email } as any) === null;
  }

  addToEmail(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (this.addEmailToSelection(value, this.selectedToEmails)) {
      event.chipInput?.clear();
      this.to.setValue('');
    }
  }

  selectToEmail(event: any): void {
    const value = event.option?.viewValue;
    if (this.addEmailToSelection(value, this.selectedToEmails)) {
      this.to.setValue('');
    }
  }

  removeToEmail(email: string): void {
    this.selectedToEmails = this.selectedToEmails.filter(e => e !== email);
  }

  addCcEmail(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (this.addEmailToSelection(value, this.selectedCcEmails)) {
      event.chipInput?.clear();
      this.cc.setValue('');
    }
  }

  selectCcEmail(event: any): void {
    const value = event.option?.viewValue;
    if (this.addEmailToSelection(value, this.selectedCcEmails)) {
      this.cc.setValue('');
    }
  }

  removeCcEmail(email: string): void {
    this.selectedCcEmails = this.selectedCcEmails.filter(e => e !== email);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  onContinue(): void {
    if (!this.isFormValid()) {
      return;
    }
    // ensure we store a string in sessionStorage
    if (this.update_signature.value) {
      sessionStorage.setItem("signature", this.email_signature.value ?? '');
    }
    this.dialogRef.close({ to: this.selectedToEmails, cc: this.selectedCcEmails, email_signature: this.email_signature.value ?? '', update_signature: this.update_signature.value ? "Y" : "N" });

  }



  private isFormValid(): boolean {
    return this.selectedToEmails.length > 0 && this.selectedCcEmails.length > 0;
  }
}
